import usersSlice from './reducer'

export default usersSlice.reducer
